<template>
<div>
	<button
		@click="handleClick($event)"
		:disabled="disabled || loading"

		:class='`${this.style} ${disabled || loading ? "cursor-not-allowed opacity-50 shadow-sm ": " hover:opacity-70 shadow-lg"} ${small ? "text-xs py-1.5 px-4": "text-sm py-2 px-5"}`'

		class="z-10 transition-colors duration-200 w-full flex justify-center gap-x-2 rounded-lg font-medium select-none text-nowrap">
		
		<!-- loading spinner -->
		

		<!-- button text -->
		{{text}}
		<svg v-if="loading" :class="small ? 'h-[14px] w-[14px]' : 'h-[18px] w-[18px]'" class="animate-spin text-white ml-[8px]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
			<circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
			<path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
		</svg>

		<LucideIcon v-if="icon && !loading" :name="icon" :size='`${small ? 15:18}`' :stroke-width="2.5" color="#ffffff" class=""/>
			
	</button>
</div>
</template>

<script>
import LucideIcon from "@/components/LucideIcon.vue";
export default {
name: "CustomButton",
components: {
	LucideIcon
    },
props: {
	text: {
	type: String,
	default: ""
	},
	disabled: {
	type: Boolean,
	default: false
	},
	loading: {
	type: Boolean,
	default: false
	},
	type: {
	type: String,
	default: "action"
	},
	textColour: {
	type: String,
	default:"white"
	},
	icon: {
	type: String
	},
	small: {
	type: Boolean,
	default: false
	}
	
},
data() {
	return {
		style: "",
		iconSize: 0,
		showConfirmModal: false
	}
    },
methods: {
	handleClick: function() {
	// this.$emit('click', event);
	}
},
created(){
	if (this.type == "action") {
		this.style = "text-white bg-gradient-to-br from-blue-600 to-blue-500 border-0 border-blue-300"
	} else if (this.type == "warning") {
		this.style = "text-white bg-gradient-to-br from-red-600 to-red-500 border-0 border-red-300"
	} else if (this.type == "navigate") {
		this.style = "text-white bg-gradient-to-br from-slate-800 to-slate-700 border-slate-400"
	} else if (this.type == "default") {
		this.style = "text-white bg-gradient-to-br from-gray-500 to-slate-400 border-slate-400"
	}
},
}
</script>